import Vue from 'vue'
import App from './App.vue'
import {store} from './store/store'
import router from "./router/index";
import axios from 'axios'
import VueAxios from 'vue-axios'
import Amplify, * as AmplifyModules from "aws-amplify";
import {AmplifyPlugin} from "aws-amplify-vue";
import awsmobile from "./aws-exports";
import vuetify from './plugins/vuetify';
import UniqueId from 'vue-unique-id';
import "@/assets/sass/app.sass";



Amplify.configure(awsmobile);

Vue.config.productionTip = false;

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(UniqueId);

axios.defaults.baseURL = process.env.VUE_APP_API_HOST;

Vue.prototype.$http = axios;

Vue.prototype.axios = axios;
new Vue({
    vuetify,
    store,
    router,
    VueAxios,
    axios,
    render: h => h(App)
}).$mount('#app');
